// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Caml_obj = require("bs-platform/lib/js/caml_obj.js");
var Infix$BsBastet = require("./Infix.bs.js");
var Option$BsBastet = require("./Option.bs.js");
var Function$BsBastet = require("./Function.bs.js");

function result(f, g, a) {
  if (a.TAG === /* Ok */0) {
    return Curry._1(f, a._0);
  } else {
    return Curry._1(g, a._0);
  }
}

function Magma(T, M) {
  var append = function (a, b) {
    if (a.TAG === /* Ok */0) {
      if (b.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: Curry._2(M.append, a._0, b._0)
              };
      }
      
    } else if (b.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: b._0
            };
    }
    if (a.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: a._0
            };
    } else {
      return {
              TAG: /* Error */1,
              _0: a._0
            };
    }
  };
  return {
          append: append
        };
}

function Medial_Magma(T, M) {
  var append = function (a, b) {
    if (a.TAG === /* Ok */0) {
      if (b.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: Curry._2(M.append, a._0, b._0)
              };
      }
      
    } else if (b.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: b._0
            };
    }
    if (a.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: a._0
            };
    } else {
      return {
              TAG: /* Error */1,
              _0: a._0
            };
    }
  };
  return {
          append: append
        };
}

function Semigroup(T, S) {
  var append = function (a, b) {
    if (a.TAG === /* Ok */0) {
      if (b.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: Curry._2(S.append, a._0, b._0)
              };
      }
      
    } else if (b.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: b._0
            };
    }
    if (a.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: a._0
            };
    } else {
      return {
              TAG: /* Error */1,
              _0: a._0
            };
    }
  };
  return {
          append: append
        };
}

function Functor(T) {
  var map = function (f, a) {
    if (a.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: Curry._1(f, a._0)
            };
    } else {
      return {
              TAG: /* Error */1,
              _0: a._0
            };
    }
  };
  return {
          map: map
        };
}

function bimap(f, g, a) {
  if (a.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: Curry._1(f, a._0)
          };
  } else {
    return {
            TAG: /* Error */1,
            _0: Curry._1(g, a._0)
          };
  }
}

var Bifunctor = {
  bimap: bimap
};

function Apply(T) {
  var map = function (f, a) {
    if (a.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: Curry._1(f, a._0)
            };
    } else {
      return {
              TAG: /* Error */1,
              _0: a._0
            };
    }
  };
  var apply = function (f, a) {
    if (f.TAG === /* Ok */0) {
      return map(f._0, a);
    } else {
      return {
              TAG: /* Error */1,
              _0: f._0
            };
    }
  };
  return {
          map: map,
          apply: apply
        };
}

function Applicative(T) {
  var map = function (f, a) {
    if (a.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: Curry._1(f, a._0)
            };
    } else {
      return {
              TAG: /* Error */1,
              _0: a._0
            };
    }
  };
  var apply = function (f, a) {
    if (f.TAG === /* Ok */0) {
      return map(f._0, a);
    } else {
      return {
              TAG: /* Error */1,
              _0: f._0
            };
    }
  };
  var pure = function (a) {
    return {
            TAG: /* Ok */0,
            _0: a
          };
  };
  return {
          map: map,
          apply: apply,
          pure: pure
        };
}

function Monad(T) {
  var map = function (f, a) {
    if (a.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: Curry._1(f, a._0)
            };
    } else {
      return {
              TAG: /* Error */1,
              _0: a._0
            };
    }
  };
  var apply = function (f, a) {
    if (f.TAG === /* Ok */0) {
      return map(f._0, a);
    } else {
      return {
              TAG: /* Error */1,
              _0: f._0
            };
    }
  };
  var pure = function (a) {
    return {
            TAG: /* Ok */0,
            _0: a
          };
  };
  var flat_map = function (a, f) {
    if (a.TAG === /* Ok */0) {
      return Curry._1(f, a._0);
    } else {
      return {
              TAG: /* Error */1,
              _0: a._0
            };
    }
  };
  return {
          map: map,
          apply: apply,
          pure: pure,
          flat_map: flat_map
        };
}

function Alt(T) {
  var map = function (f, a) {
    if (a.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: Curry._1(f, a._0)
            };
    } else {
      return {
              TAG: /* Error */1,
              _0: a._0
            };
    }
  };
  var alt = function (a, b) {
    if (a.TAG === /* Ok */0) {
      return a;
    } else {
      return b;
    }
  };
  return {
          map: map,
          alt: alt
        };
}

function Extend(T) {
  var map = function (f, a) {
    if (a.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: Curry._1(f, a._0)
            };
    } else {
      return {
              TAG: /* Error */1,
              _0: a._0
            };
    }
  };
  var extend = function (f, a) {
    if (a.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: Curry._1(f, a)
            };
    } else {
      return {
              TAG: /* Error */1,
              _0: a._0
            };
    }
  };
  return {
          map: map,
          extend: extend
        };
}

function Show(Ok, $$Error) {
  var show = function (param) {
    return result(Ok.show, $$Error.show, param);
  };
  return {
          show: show
        };
}

function Eq(Ok, $$Error) {
  var eq = function (a, b) {
    if (a.TAG === /* Ok */0) {
      if (b.TAG === /* Ok */0) {
        return Curry._2(Ok.eq, a._0, b._0);
      } else {
        return false;
      }
    } else if (b.TAG === /* Ok */0) {
      return false;
    } else {
      return Curry._2($$Error.eq, a._0, b._0);
    }
  };
  return {
          eq: eq
        };
}

function Ord(Ok, $$Error) {
  var eq = function (a, b) {
    if (a.TAG === /* Ok */0) {
      if (b.TAG === /* Ok */0) {
        return Curry._2(Ok.eq, a._0, b._0);
      } else {
        return false;
      }
    } else if (b.TAG === /* Ok */0) {
      return false;
    } else {
      return Curry._2($$Error.eq, a._0, b._0);
    }
  };
  var include = {
    eq: eq
  };
  var compare = function (a, b) {
    if (a.TAG === /* Ok */0) {
      if (b.TAG === /* Ok */0) {
        return Curry._2(Ok.compare, a._0, b._0);
      } else {
        return "greater_than";
      }
    } else if (b.TAG === /* Ok */0) {
      return "less_than";
    } else {
      return Curry._2($$Error.compare, a._0, b._0);
    }
  };
  return {
          eq: include.eq,
          compare: compare
        };
}

function Bounded(Ok, $$Error) {
  var eq = function (a, b) {
    if (a.TAG === /* Ok */0) {
      if (b.TAG === /* Ok */0) {
        return Curry._2(Ok.eq, a._0, b._0);
      } else {
        return false;
      }
    } else if (b.TAG === /* Ok */0) {
      return false;
    } else {
      return Curry._2($$Error.eq, a._0, b._0);
    }
  };
  var include = {
    eq: eq
  };
  var compare = function (a, b) {
    if (a.TAG === /* Ok */0) {
      if (b.TAG === /* Ok */0) {
        return Curry._2(Ok.compare, a._0, b._0);
      } else {
        return "greater_than";
      }
    } else if (b.TAG === /* Ok */0) {
      return "less_than";
    } else {
      return Curry._2($$Error.compare, a._0, b._0);
    }
  };
  var include_eq = include.eq;
  var top = {
    TAG: /* Ok */0,
    _0: Ok.top
  };
  var bottom = {
    TAG: /* Error */1,
    _0: $$Error.bottom
  };
  return {
          eq: include_eq,
          compare: compare,
          top: top,
          bottom: bottom
        };
}

function Quasireflexive_Eq(Ok, $$Error) {
  var eq = function (a, b) {
    if (a.TAG === /* Ok */0) {
      if (b.TAG === /* Ok */0) {
        return true;
      } else {
        return false;
      }
    } else if (b.TAG === /* Ok */0) {
      return false;
    } else {
      return true;
    }
  };
  return {
          eq: eq
        };
}

function Quasireflexive_Ord(Ok, $$Error) {
  var eq = function (a, b) {
    if (a.TAG === /* Ok */0) {
      if (b.TAG === /* Ok */0) {
        return true;
      } else {
        return false;
      }
    } else if (b.TAG === /* Ok */0) {
      return false;
    } else {
      return true;
    }
  };
  var include = {
    eq: eq
  };
  var compare = function (a, b) {
    if (a.TAG === /* Ok */0) {
      if (b.TAG === /* Ok */0) {
        return "equal_to";
      } else {
        return "greater_than";
      }
    } else if (b.TAG === /* Ok */0) {
      return "less_than";
    } else {
      return "equal_to";
    }
  };
  return {
          eq: include.eq,
          compare: compare
        };
}

function Join_Semilattice(Ok, $$Error) {
  var join = function (a, b) {
    if (a.TAG !== /* Ok */0) {
      if (b.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: b._0
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: Curry._2($$Error.join, a._0, b._0)
              };
      }
    }
    var a$prime = a._0;
    if (b.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: Curry._2(Ok.join, a$prime, b._0)
            };
    } else {
      return {
              TAG: /* Ok */0,
              _0: a$prime
            };
    }
  };
  return {
          join: join
        };
}

function Meet_Semilattice(Ok, $$Error) {
  var meet = function (a, b) {
    if (a.TAG === /* Ok */0) {
      if (b.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: Curry._2(Ok.meet, a._0, b._0)
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: b._0
              };
      }
    }
    var a$prime = a._0;
    if (b.TAG === /* Ok */0) {
      return {
              TAG: /* Error */1,
              _0: a$prime
            };
    } else {
      return {
              TAG: /* Error */1,
              _0: Curry._2($$Error.meet, a$prime, b._0)
            };
    }
  };
  return {
          meet: meet
        };
}

function Bounded_Join_Semilattice(Ok, $$Error) {
  var join = function (a, b) {
    if (a.TAG !== /* Ok */0) {
      if (b.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: b._0
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: Curry._2($$Error.join, a._0, b._0)
              };
      }
    }
    var a$prime = a._0;
    if (b.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: Curry._2(Ok.join, a$prime, b._0)
            };
    } else {
      return {
              TAG: /* Ok */0,
              _0: a$prime
            };
    }
  };
  var include = {
    join: join
  };
  var bottom = {
    TAG: /* Error */1,
    _0: $$Error.bottom
  };
  return {
          join: include.join,
          bottom: bottom
        };
}

function Bounded_Meet_Semilattice(Ok, $$Error) {
  var meet = function (a, b) {
    if (a.TAG === /* Ok */0) {
      if (b.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: Curry._2(Ok.meet, a._0, b._0)
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: b._0
              };
      }
    }
    var a$prime = a._0;
    if (b.TAG === /* Ok */0) {
      return {
              TAG: /* Error */1,
              _0: a$prime
            };
    } else {
      return {
              TAG: /* Error */1,
              _0: Curry._2($$Error.meet, a$prime, b._0)
            };
    }
  };
  var include = {
    meet: meet
  };
  var top = {
    TAG: /* Ok */0,
    _0: Ok.top
  };
  return {
          meet: include.meet,
          top: top
        };
}

function Lattice(Ok, $$Error) {
  var join = function (a, b) {
    if (a.TAG !== /* Ok */0) {
      if (b.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: b._0
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: Curry._2($$Error.join, a._0, b._0)
              };
      }
    }
    var a$prime = a._0;
    if (b.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: Curry._2(Ok.join, a$prime, b._0)
            };
    } else {
      return {
              TAG: /* Ok */0,
              _0: a$prime
            };
    }
  };
  var include = {
    join: join
  };
  var meet = function (a, b) {
    if (a.TAG === /* Ok */0) {
      if (b.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: Curry._2(Ok.meet, a._0, b._0)
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: b._0
              };
      }
    }
    var a$prime = a._0;
    if (b.TAG === /* Ok */0) {
      return {
              TAG: /* Error */1,
              _0: a$prime
            };
    } else {
      return {
              TAG: /* Error */1,
              _0: Curry._2($$Error.meet, a$prime, b._0)
            };
    }
  };
  var include$1 = {
    meet: meet
  };
  return {
          join: include.join,
          meet: include$1.meet
        };
}

function Bounded_Lattice(Ok, $$Error) {
  var join = function (a, b) {
    if (a.TAG !== /* Ok */0) {
      if (b.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: b._0
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: Curry._2($$Error.join, a._0, b._0)
              };
      }
    }
    var a$prime = a._0;
    if (b.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: Curry._2(Ok.join, a$prime, b._0)
            };
    } else {
      return {
              TAG: /* Ok */0,
              _0: a$prime
            };
    }
  };
  var include = {
    join: join
  };
  var bottom = {
    TAG: /* Error */1,
    _0: $$Error.bottom
  };
  var include_join = include.join;
  var meet = function (a, b) {
    if (a.TAG === /* Ok */0) {
      if (b.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: Curry._2(Ok.meet, a._0, b._0)
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: b._0
              };
      }
    }
    var a$prime = a._0;
    if (b.TAG === /* Ok */0) {
      return {
              TAG: /* Error */1,
              _0: a$prime
            };
    } else {
      return {
              TAG: /* Error */1,
              _0: Curry._2($$Error.meet, a$prime, b._0)
            };
    }
  };
  var include$1 = {
    meet: meet
  };
  var top = {
    TAG: /* Ok */0,
    _0: Ok.top
  };
  var include_meet = include$1.meet;
  return {
          join: include_join,
          bottom: bottom,
          meet: include_meet,
          top: top
        };
}

function Distributive_Lattice(Ok, $$Error) {
  var join = function (a, b) {
    if (a.TAG !== /* Ok */0) {
      if (b.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: b._0
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: Curry._2($$Error.join, a._0, b._0)
              };
      }
    }
    var a$prime = a._0;
    if (b.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: Curry._2(Ok.join, a$prime, b._0)
            };
    } else {
      return {
              TAG: /* Ok */0,
              _0: a$prime
            };
    }
  };
  var include = {
    join: join
  };
  var partial_arg = {
    meet: Ok.meet
  };
  var meet = function (a, b) {
    if (a.TAG === /* Ok */0) {
      if (b.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: Curry._2(partial_arg.meet, a._0, b._0)
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: b._0
              };
      }
    }
    var a$prime = a._0;
    if (b.TAG === /* Ok */0) {
      return {
              TAG: /* Error */1,
              _0: a$prime
            };
    } else {
      return {
              TAG: /* Error */1,
              _0: Curry._2($$Error.meet, a$prime, b._0)
            };
    }
  };
  var include$1 = {
    meet: meet
  };
  return {
          join: include.join,
          meet: include$1.meet
        };
}

function Bounded_Distributive_Lattice(Ok, $$Error) {
  var join = function (a, b) {
    if (a.TAG !== /* Ok */0) {
      if (b.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: b._0
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: Curry._2($$Error.join, a._0, b._0)
              };
      }
    }
    var a$prime = a._0;
    if (b.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: Curry._2(Ok.join, a$prime, b._0)
            };
    } else {
      return {
              TAG: /* Ok */0,
              _0: a$prime
            };
    }
  };
  var include = {
    join: join
  };
  var bottom = {
    TAG: /* Error */1,
    _0: $$Error.bottom
  };
  var include_join = include.join;
  var partial_arg_meet = Ok.meet;
  var partial_arg_top = Ok.top;
  var meet = function (a, b) {
    if (a.TAG === /* Ok */0) {
      if (b.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: Curry._2(partial_arg_meet, a._0, b._0)
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: b._0
              };
      }
    }
    var a$prime = a._0;
    if (b.TAG === /* Ok */0) {
      return {
              TAG: /* Error */1,
              _0: a$prime
            };
    } else {
      return {
              TAG: /* Error */1,
              _0: Curry._2($$Error.meet, a$prime, b._0)
            };
    }
  };
  var include$1 = {
    meet: meet
  };
  var top = {
    TAG: /* Ok */0,
    _0: partial_arg_top
  };
  var include_meet = include$1.meet;
  return {
          join: include_join,
          bottom: bottom,
          meet: include_meet,
          top: top
        };
}

function Heyting_Algebra(Ok, $$Error) {
  var eq = function (a, b) {
    if (a.TAG === /* Ok */0) {
      if (b.TAG === /* Ok */0) {
        return true;
      } else {
        return false;
      }
    } else if (b.TAG === /* Ok */0) {
      return false;
    } else {
      return true;
    }
  };
  var include = {
    eq: eq
  };
  var compare = function (a, b) {
    if (a.TAG === /* Ok */0) {
      if (b.TAG === /* Ok */0) {
        return "equal_to";
      } else {
        return "greater_than";
      }
    } else if (b.TAG === /* Ok */0) {
      return "less_than";
    } else {
      return "equal_to";
    }
  };
  var include_eq = include.eq;
  var Error_join = $$Error.join;
  var Error_bottom = $$Error.bottom;
  var Error_meet = $$Error.meet;
  var Error_top = $$Error.top;
  var join = function (a, b) {
    if (a.TAG !== /* Ok */0) {
      if (b.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: b._0
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: Curry._2($$Error.join, a._0, b._0)
              };
      }
    }
    var a$prime = a._0;
    if (b.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: Curry._2(Ok.join, a$prime, b._0)
            };
    } else {
      return {
              TAG: /* Ok */0,
              _0: a$prime
            };
    }
  };
  var include$1 = {
    join: join
  };
  var bottom = {
    TAG: /* Error */1,
    _0: $$Error.bottom
  };
  var include_join = include$1.join;
  var partial_arg_meet = Ok.meet;
  var partial_arg_top = Ok.top;
  var meet = function (a, b) {
    if (a.TAG === /* Ok */0) {
      if (b.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: Curry._2(partial_arg_meet, a._0, b._0)
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: b._0
              };
      }
    }
    var a$prime = a._0;
    if (b.TAG === /* Ok */0) {
      return {
              TAG: /* Error */1,
              _0: a$prime
            };
    } else {
      return {
              TAG: /* Error */1,
              _0: Curry._2(Error_meet, a$prime, b._0)
            };
    }
  };
  var include$2 = {
    meet: meet
  };
  var top = {
    TAG: /* Ok */0,
    _0: partial_arg_top
  };
  var include_meet = include$2.meet;
  var include_join$1 = include_join;
  var include_bottom = bottom;
  var include_meet$1 = include_meet;
  var include_top = top;
  var join$1 = include_join$1;
  var not = function (a) {
    if (a.TAG === /* Ok */0) {
      var a$prime = a._0;
      if (Caml_obj.caml_equal(a$prime, Ok.top)) {
        return {
                TAG: /* Error */1,
                _0: $$Error.bottom
              };
      } else if (Caml_obj.caml_equal(a$prime, Ok.bottom)) {
        return {
                TAG: /* Error */1,
                _0: $$Error.top
              };
      } else {
        return a;
      }
    }
    var a$prime$1 = a._0;
    if (Caml_obj.caml_equal(a$prime$1, $$Error.top)) {
      return {
              TAG: /* Ok */0,
              _0: Ok.bottom
            };
    } else if (Caml_obj.caml_equal(a$prime$1, $$Error.bottom)) {
      return {
              TAG: /* Ok */0,
              _0: Ok.top
            };
    } else {
      return a;
    }
  };
  var implies = function (a, b) {
    return Curry._2(join$1, not(a), b);
  };
  return {
          eq: include_eq,
          compare: compare,
          join: join$1,
          bottom: include_bottom,
          meet: include_meet$1,
          top: include_top,
          not: not,
          implies: implies
        };
}

function Involutive_Heyting_Algebra(Ok, $$Error) {
  var eq = function (a, b) {
    if (a.TAG === /* Ok */0) {
      if (b.TAG === /* Ok */0) {
        return true;
      } else {
        return false;
      }
    } else if (b.TAG === /* Ok */0) {
      return false;
    } else {
      return true;
    }
  };
  var include = {
    eq: eq
  };
  var compare = function (a, b) {
    if (a.TAG === /* Ok */0) {
      if (b.TAG === /* Ok */0) {
        return "equal_to";
      } else {
        return "greater_than";
      }
    } else if (b.TAG === /* Ok */0) {
      return "less_than";
    } else {
      return "equal_to";
    }
  };
  var include_eq = include.eq;
  var partial_arg_join = Ok.join;
  var partial_arg_bottom = Ok.bottom;
  var partial_arg_meet = Ok.meet;
  var partial_arg_top = Ok.top;
  var Error_join = $$Error.join;
  var Error_bottom = $$Error.bottom;
  var Error_meet = $$Error.meet;
  var Error_top = $$Error.top;
  var join = function (a, b) {
    if (a.TAG !== /* Ok */0) {
      if (b.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: b._0
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: Curry._2($$Error.join, a._0, b._0)
              };
      }
    }
    var a$prime = a._0;
    if (b.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: Curry._2(partial_arg_join, a$prime, b._0)
            };
    } else {
      return {
              TAG: /* Ok */0,
              _0: a$prime
            };
    }
  };
  var include$1 = {
    join: join
  };
  var bottom = {
    TAG: /* Error */1,
    _0: $$Error.bottom
  };
  var include_join = include$1.join;
  var partial_arg_meet$1 = partial_arg_meet;
  var partial_arg_top$1 = partial_arg_top;
  var meet = function (a, b) {
    if (a.TAG === /* Ok */0) {
      if (b.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: Curry._2(partial_arg_meet$1, a._0, b._0)
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: b._0
              };
      }
    }
    var a$prime = a._0;
    if (b.TAG === /* Ok */0) {
      return {
              TAG: /* Error */1,
              _0: a$prime
            };
    } else {
      return {
              TAG: /* Error */1,
              _0: Curry._2(Error_meet, a$prime, b._0)
            };
    }
  };
  var include$2 = {
    meet: meet
  };
  var top = {
    TAG: /* Ok */0,
    _0: partial_arg_top$1
  };
  var include_meet = include$2.meet;
  var include_join$1 = include_join;
  var include_bottom = bottom;
  var include_meet$1 = include_meet;
  var include_top = top;
  var join$1 = include_join$1;
  var not = function (a) {
    if (a.TAG === /* Ok */0) {
      var a$prime = a._0;
      if (Caml_obj.caml_equal(a$prime, Ok.top)) {
        return {
                TAG: /* Error */1,
                _0: $$Error.bottom
              };
      } else if (Caml_obj.caml_equal(a$prime, Ok.bottom)) {
        return {
                TAG: /* Error */1,
                _0: $$Error.top
              };
      } else {
        return a;
      }
    }
    var a$prime$1 = a._0;
    if (Caml_obj.caml_equal(a$prime$1, $$Error.top)) {
      return {
              TAG: /* Ok */0,
              _0: Ok.bottom
            };
    } else if (Caml_obj.caml_equal(a$prime$1, $$Error.bottom)) {
      return {
              TAG: /* Ok */0,
              _0: Ok.top
            };
    } else {
      return a;
    }
  };
  var implies = function (a, b) {
    return Curry._2(join$1, not(a), b);
  };
  return {
          eq: include_eq,
          compare: compare,
          join: join$1,
          bottom: include_bottom,
          meet: include_meet$1,
          top: include_top,
          not: not,
          implies: implies
        };
}

function Boolean_Algebra(Ok, $$Error) {
  var eq = function (a, b) {
    if (a.TAG === /* Ok */0) {
      if (b.TAG === /* Ok */0) {
        return true;
      } else {
        return false;
      }
    } else if (b.TAG === /* Ok */0) {
      return false;
    } else {
      return true;
    }
  };
  var include = {
    eq: eq
  };
  var compare = function (a, b) {
    if (a.TAG === /* Ok */0) {
      if (b.TAG === /* Ok */0) {
        return "equal_to";
      } else {
        return "greater_than";
      }
    } else if (b.TAG === /* Ok */0) {
      return "less_than";
    } else {
      return "equal_to";
    }
  };
  var include_eq = include.eq;
  var partial_arg_join = Ok.join;
  var partial_arg_bottom = Ok.bottom;
  var partial_arg_meet = Ok.meet;
  var partial_arg_top = Ok.top;
  var Error_join = $$Error.join;
  var Error_bottom = $$Error.bottom;
  var Error_meet = $$Error.meet;
  var Error_top = $$Error.top;
  var join = function (a, b) {
    if (a.TAG !== /* Ok */0) {
      if (b.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: b._0
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: Curry._2($$Error.join, a._0, b._0)
              };
      }
    }
    var a$prime = a._0;
    if (b.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: Curry._2(partial_arg_join, a$prime, b._0)
            };
    } else {
      return {
              TAG: /* Ok */0,
              _0: a$prime
            };
    }
  };
  var include$1 = {
    join: join
  };
  var bottom = {
    TAG: /* Error */1,
    _0: $$Error.bottom
  };
  var include_join = include$1.join;
  var partial_arg_meet$1 = partial_arg_meet;
  var partial_arg_top$1 = partial_arg_top;
  var meet = function (a, b) {
    if (a.TAG === /* Ok */0) {
      if (b.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: Curry._2(partial_arg_meet$1, a._0, b._0)
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: b._0
              };
      }
    }
    var a$prime = a._0;
    if (b.TAG === /* Ok */0) {
      return {
              TAG: /* Error */1,
              _0: a$prime
            };
    } else {
      return {
              TAG: /* Error */1,
              _0: Curry._2(Error_meet, a$prime, b._0)
            };
    }
  };
  var include$2 = {
    meet: meet
  };
  var top = {
    TAG: /* Ok */0,
    _0: partial_arg_top$1
  };
  var include_meet = include$2.meet;
  var include_join$1 = include_join;
  var include_bottom = bottom;
  var include_meet$1 = include_meet;
  var include_top = top;
  var join$1 = include_join$1;
  var not = function (a) {
    if (a.TAG === /* Ok */0) {
      var a$prime = a._0;
      if (Caml_obj.caml_equal(a$prime, Ok.top)) {
        return {
                TAG: /* Error */1,
                _0: $$Error.bottom
              };
      } else if (Caml_obj.caml_equal(a$prime, Ok.bottom)) {
        return {
                TAG: /* Error */1,
                _0: $$Error.top
              };
      } else {
        return a;
      }
    }
    var a$prime$1 = a._0;
    if (Caml_obj.caml_equal(a$prime$1, $$Error.top)) {
      return {
              TAG: /* Ok */0,
              _0: Ok.bottom
            };
    } else if (Caml_obj.caml_equal(a$prime$1, $$Error.bottom)) {
      return {
              TAG: /* Ok */0,
              _0: Ok.top
            };
    } else {
      return a;
    }
  };
  var implies = function (a, b) {
    return Curry._2(join$1, not(a), b);
  };
  return {
          eq: include_eq,
          compare: compare,
          join: join$1,
          bottom: include_bottom,
          meet: include_meet$1,
          top: include_top,
          not: not,
          implies: implies
        };
}

var Many_Valued_Logic = {
  Quasireflexive_Eq: Quasireflexive_Eq,
  Quasireflexive_Ord: Quasireflexive_Ord,
  Join_Semilattice: Join_Semilattice,
  Meet_Semilattice: Meet_Semilattice,
  Bounded_Join_Semilattice: Bounded_Join_Semilattice,
  Bounded_Meet_Semilattice: Bounded_Meet_Semilattice,
  Lattice: Lattice,
  Bounded_Lattice: Bounded_Lattice,
  Distributive_Lattice: Distributive_Lattice,
  Bounded_Distributive_Lattice: Bounded_Distributive_Lattice,
  Heyting_Algebra: Heyting_Algebra,
  Involutive_Heyting_Algebra: Involutive_Heyting_Algebra,
  Boolean_Algebra: Boolean_Algebra
};

function Foldable(T) {
  var fold_left = function (f, initial, a) {
    if (a.TAG === /* Ok */0) {
      return Curry._2(f, initial, a._0);
    } else {
      return initial;
    }
  };
  var fold_right = function (f, initial, a) {
    if (a.TAG === /* Ok */0) {
      return Curry._2(f, a._0, initial);
    } else {
      return initial;
    }
  };
  var Fold_Map = function (M) {
    var fold_map = function (f, a) {
      if (a.TAG === /* Ok */0) {
        return Curry._1(f, a._0);
      } else {
        return M.empty;
      }
    };
    return {
            fold_map: fold_map
          };
  };
  var Fold_Map_Plus = function (P) {
    var fold_map = function (f, a) {
      if (a.TAG === /* Ok */0) {
        return Curry._1(f, a._0);
      } else {
        return P.empty;
      }
    };
    return {
            fold_map: fold_map
          };
  };
  var Fold_Map_Any = function (M) {
    var fold_map = function (f, a) {
      if (a.TAG === /* Ok */0) {
        return Curry._1(f, a._0);
      } else {
        return M.empty;
      }
    };
    return {
            fold_map: fold_map
          };
  };
  return {
          fold_left: fold_left,
          fold_right: fold_right,
          Fold_Map: Fold_Map,
          Fold_Map_Any: Fold_Map_Any,
          Fold_Map_Plus: Fold_Map_Plus
        };
}

function bifold_left(f, g, initial, a) {
  if (a.TAG === /* Ok */0) {
    return Curry._2(f, initial, a._0);
  } else {
    return Curry._2(g, initial, a._0);
  }
}

function bifold_right(f, g, initial, a) {
  if (a.TAG === /* Ok */0) {
    return Curry._2(f, a._0, initial);
  } else {
    return Curry._2(g, a._0, initial);
  }
}

function Fold_Map(M) {
  return {
          fold_map: result
        };
}

function Fold_Map_Any(M) {
  return {
          fold_map: result
        };
}

function Fold_Map_Plus(P) {
  return {
          fold_map: result
        };
}

var Bifoldable = {
  bifold_left: bifold_left,
  bifold_right: bifold_right,
  Fold_Map: Fold_Map,
  Fold_Map_Any: Fold_Map_Any,
  Fold_Map_Plus: Fold_Map_Plus
};

function Traversable(T, A) {
  var pure = function (a) {
    return {
            TAG: /* Ok */0,
            _0: a
          };
  };
  var map = function (f, a) {
    if (a.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: Curry._1(f, a._0)
            };
    } else {
      return {
              TAG: /* Error */1,
              _0: a._0
            };
    }
  };
  var fold_left = function (f, initial, a) {
    if (a.TAG === /* Ok */0) {
      return Curry._2(f, initial, a._0);
    } else {
      return initial;
    }
  };
  var fold_right = function (f, initial, a) {
    if (a.TAG === /* Ok */0) {
      return Curry._2(f, a._0, initial);
    } else {
      return initial;
    }
  };
  var Fold_Map = function (M) {
    var fold_map = function (f, a) {
      if (a.TAG === /* Ok */0) {
        return Curry._1(f, a._0);
      } else {
        return M.empty;
      }
    };
    return {
            fold_map: fold_map
          };
  };
  var Fold_Map_Plus = function (P) {
    var fold_map = function (f, a) {
      if (a.TAG === /* Ok */0) {
        return Curry._1(f, a._0);
      } else {
        return P.empty;
      }
    };
    return {
            fold_map: fold_map
          };
  };
  var Fold_Map_Any = function (M) {
    var fold_map = function (f, a) {
      if (a.TAG === /* Ok */0) {
        return Curry._1(f, a._0);
      } else {
        return M.empty;
      }
    };
    return {
            fold_map: fold_map
          };
  };
  var traverse = function (f, a) {
    if (a.TAG === /* Ok */0) {
      return Curry._2(A.map, pure, Curry._1(f, a._0));
    } else {
      return Curry._1(A.pure, {
                  TAG: /* Error */1,
                  _0: a._0
                });
    }
  };
  var sequence = function (a) {
    if (a.TAG === /* Ok */0) {
      return Curry._2(A.map, pure, a._0);
    } else {
      return Curry._1(A.pure, {
                  TAG: /* Error */1,
                  _0: a._0
                });
    }
  };
  return {
          map: map,
          fold_left: fold_left,
          fold_right: fold_right,
          Fold_Map: Fold_Map,
          Fold_Map_Any: Fold_Map_Any,
          Fold_Map_Plus: Fold_Map_Plus,
          traverse: traverse,
          sequence: sequence
        };
}

function Bitraversable(A) {
  var bitraverse = function (f, g, a) {
    if (a.TAG === /* Ok */0) {
      return Curry._2(A.map, (function (x) {
                    return {
                            TAG: /* Ok */0,
                            _0: x
                          };
                  }), Curry._1(f, a._0));
    } else {
      return Curry._2(A.map, (function (x) {
                    return {
                            TAG: /* Error */1,
                            _0: x
                          };
                  }), Curry._1(g, a._0));
    }
  };
  var bisequence = function (a) {
    if (a.TAG === /* Ok */0) {
      return Curry._2(A.map, (function (x) {
                    return {
                            TAG: /* Ok */0,
                            _0: x
                          };
                  }), a._0);
    } else {
      return Curry._2(A.map, (function (x) {
                    return {
                            TAG: /* Error */1,
                            _0: x
                          };
                  }), a._0);
    }
  };
  return {
          bimap: bimap,
          bifold_left: bifold_left,
          bifold_right: bifold_right,
          Fold_Map: Fold_Map,
          Fold_Map_Any: Fold_Map_Any,
          Fold_Map_Plus: Fold_Map_Plus,
          bitraverse: bitraverse,
          bisequence: bisequence
        };
}

var include = Infix$BsBastet.Bifunctor(Bifunctor);

var Infix = include;

function Choose(A) {
  var choose = function (a, b) {
    return Curry._2(A.alt, Curry._2(A.map, (function (x) {
                      return {
                              TAG: /* Ok */0,
                              _0: x
                            };
                    }), a), Curry._2(A.map, (function (x) {
                      return {
                              TAG: /* Error */1,
                              _0: x
                            };
                    }), b));
  };
  return {
          choose: choose
        };
}

function from_ok(a) {
  if (a.TAG === /* Ok */0) {
    return a._0;
  }
  throw {
        RE_EXN_ID: "Invalid_argument",
        _1: "You passed in an `Error` value to `from_ok`",
        Error: new Error()
      };
}

function from_error(a) {
  if (a.TAG !== /* Ok */0) {
    return a._0;
  }
  throw {
        RE_EXN_ID: "Invalid_argument",
        _1: "You passed in an `Ok` value to `from_error`",
        Error: new Error()
      };
}

var Unsafe = {
  from_ok: from_ok,
  from_error: from_error
};

function is_ok(a) {
  return result((function (param) {
                return Function$BsBastet.$$const(true, param);
              }), (function (param) {
                return Function$BsBastet.$$const(false, param);
              }), a);
}

function is_error(a) {
  return result((function (param) {
                return Function$BsBastet.$$const(false, param);
              }), (function (param) {
                return Function$BsBastet.$$const(true, param);
              }), a);
}

function note($$default) {
  var partial_arg = {
    TAG: /* Error */1,
    _0: $$default
  };
  return function (param) {
    return Option$BsBastet.maybe((function (x) {
                  return {
                          TAG: /* Ok */0,
                          _0: x
                        };
                }), partial_arg, param);
  };
}

function hush(e) {
  return result(Option$BsBastet.Applicative.pure, (function (param) {
                return Function$BsBastet.$$const(undefined, param);
              }), e);
}

var flip = Function$BsBastet.flip;

var $$const = Function$BsBastet.$$const;

exports.flip = flip;
exports.$$const = $$const;
exports.result = result;
exports.Magma = Magma;
exports.Medial_Magma = Medial_Magma;
exports.Semigroup = Semigroup;
exports.Functor = Functor;
exports.Bifunctor = Bifunctor;
exports.Apply = Apply;
exports.Applicative = Applicative;
exports.Monad = Monad;
exports.Alt = Alt;
exports.Extend = Extend;
exports.Show = Show;
exports.Eq = Eq;
exports.Ord = Ord;
exports.Bounded = Bounded;
exports.Many_Valued_Logic = Many_Valued_Logic;
exports.Foldable = Foldable;
exports.Bifoldable = Bifoldable;
exports.Traversable = Traversable;
exports.Bitraversable = Bitraversable;
exports.Infix = Infix;
exports.Choose = Choose;
exports.Unsafe = Unsafe;
exports.is_ok = is_ok;
exports.is_error = is_error;
exports.note = note;
exports.hush = hush;
/* include Not a pure module */
